import type { KioskOrderTypeCode, KioskRole } from '../../contexts/KioskModeContext';

/** Guest cart API order type: 1 = dine-in, 3 = takeaway. */
export function kioskCodeToGuestType(code: KioskOrderTypeCode): number {
  return code === 'TAKEAWAY' ? 3 : 1;
}

/** Order type fixed for this kiosk session (no delivery on kiosk). */
export function resolveKioskGuestOrderType(
  role: KioskRole,
  orderTypes: KioskOrderTypeCode[],
  storedGuestType: number | null | undefined
): number {
  if (role === 'TABLE_KIOSK') {
    return 1;
  }
  if (orderTypes.length === 1) {
    return kioskCodeToGuestType(orderTypes[0]);
  }
  const allowed = orderTypes.map(kioskCodeToGuestType);
  if (storedGuestType != null && allowed.includes(storedGuestType)) {
    return storedGuestType;
  }
  return kioskCodeToGuestType(orderTypes[0] ?? 'DINEIN');
}
